export const config = {
  title: "Crossroads Road Service | 24/7 Roadside Assistance in Kenduskeag, ME",
  meta: {
    description:
      "Crossroads Road Service offers reliable 24/7 roadside assistance, including towing, jump starts, lockouts, and tire changes in Kenduskeag, ME, and surrounding areas.",
    keywords: [
      "Crossroads Road Service",
      "Roadside Assistance Kenduskeag ME",
      "Towing Services Kenduskeag",
      "Emergency Roadside Help",
      "Jump Starts",
      "Lockout Services",
      "Tire Changes"
    ],
    author: "Crossroads Road Service",
    canonicalUrl: "https://crossroadsroadservices.com/"
  },
  sections: {
    header: {
      businessName: "Crossroads Road Service"
    },
    sectionB: {
      heroTitle: "Your Reliable 24/7 Roadside Assistance Partner",
      heroSubtitle: "Serving Kenduskeag, ME, and Surrounding Areas",
      learnAboutText: "Learn More",
      phoneNumber: "2073856656",
      phoneLabel: "(207) 385-6656",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1354310306/photo/broken-semi-truck-on-side-of-a-highway.jpg?s=612x612&w=0&k=20&c=HgsQpdDdFv0AkKQPBp7ijve1IEDXe6i3MXwao-TzMpg=",
      cardData: [
        {
          title: "24/7 Emergency Service",
          description:
            "We're available around the clock to assist you with any roadside emergencies."
        },
        {
          title: "Fast Response Time",
          description:
            "Our team ensures quick arrival to get you back on the road promptly."
        },
        {
          title: "Professional Technicians",
          description:
            "Experienced and certified technicians ready to handle all your roadside needs."
        }
      ],
      description:
        "At Crossroads Road Service, we provide comprehensive roadside assistance services, ensuring you're never stranded. Our commitment is to deliver prompt and professional help whenever you need it."
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Comprehensive roadside assistance services tailored to your needs.",
      cards: [
        {
          title: "Towing Services",
          description:
            "Safe and reliable towing services for vehicles of all sizes.",
          imageSrc: "https://media.istockphoto.com/id/933911636/photo/road-assistance-truck.jpg?s=612x612&w=0&k=20&c=6K9peW0-LYPcgCwEeKRSVcwgP9OSRwnXcT2rc1BY_IE=",
          imageAlt: "Towing Services"
        },
        {
          title: "Jump Starts",
          description:
            "Quick jump start services to get your vehicle running again.",
          imageSrc: "https://media.istockphoto.com/id/1248165946/photo/car-or-vehicle-preventive-maintenance-concept.jpg?s=612x612&w=0&k=20&c=YTvuGN2UhDmeyByqmnA2OfK13hS1YVqAwuG7kv5QvN8=",
          imageAlt: "Jump Start Services"
        },
        {
          title: "Lockout Assistance",
          description:
            "Locked out? Our technicians can help you regain access to your vehicle.",
          imageSrc: "https://media.istockphoto.com/id/1305640728/photo/african-american-truck-driver-climbing-into-semi-truck.jpg?s=612x612&w=0&k=20&c=uoRsRRBFFYjpAtqOaAx6QCJkJVST0kl2ffHQsOrFj7M=",
          imageAlt: "Lockout Assistance"
        }
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Tire Changes",
        "Fuel Delivery",
        "Winching Services",
        "Battery Replacement",
        "Emergency Roadside Repairs"
      ]
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://crossroadsroadservices.com/wp-content/uploads/2025/04/01-1.jpg",
        alt: "Crossroads Road Service Team"
      },
      aboutText: [
        "Crossroads Road Service is a trusted provider of roadside assistance in Kenduskeag, ME. Our mission is to ensure drivers receive prompt and professional help during roadside emergencies.",
        "With a team of experienced technicians and a fleet of well-equipped vehicles, we are committed to delivering top-notch services to our community."
      ]
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Crossroads Road Service Logo",
      businessName: "Crossroads Road Service",
      contact: {
        phone: "2073856656",
        phoneLabel: "(207) 385-6656",
        email: "crossroads.roadservice25@gmail.com",
        website: "https://crossroadsroadservices.com/",
        address: "Kenduskeag, ME 04450"
      },
      socialMedia: {
        facebook: null, // Add Facebook URL if available
        instagram: null, // Add Instagram URL if available
        twitter: null, // Add Twitter URL if available
        linkedIn: null, // Add LinkedIn URL if available
        youtube: null // Add YouTube URL if available
      }
    },
    sectionF: {
      address: "Kenduskeag, ME 04450",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2840.123456789!2d-68.905123!3d44.959123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cae1234567890ab%3A0x123456789abcdef!2sKenduskeag%2C%20ME%2004450!5e0!3m2!1sen!2sus!4v1611234567890!5m2!1sen!2sus"
    }
  }
};

export default config;
